<template>
  <svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M8 3L1 9H3V15H7V11H9V15H13V9H15L8 3M11.5 9V13.5H10.5V9.5H5.5V13.5H4.5V8L8 5L11.5 8V9M9 16V18H15V16L18 19L15 22V20H9V22L6 19L9 16M23 9H21V15H15V10H19L13.54 5.11L16 3L23 9Z" />
  </svg>
</template>

<script>
export default {
  name: "HomeSwitchOutline"
}
</script>

<style scoped>

</style>
